export default __webpack_public_path__ + "images/82341785ba309f80d4e3f1c928b1041a-family.jpg";